import { AfterViewInit, Component, DoCheck, OnInit, ViewEncapsulation } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { EmitterService } from '../services/emitter.service';
import { swiperGrid4Config, swiperSeoConfig } from '../shared/utility/config';
import { GameWindowService } from '../services/gameWindow.services';
import * as $ from "jquery";
window["$"] = window["jQuery"] = $;
import * as _ from "underscore";
import { Router } from '@angular/router';
import { UserDetailsService } from '../services/user-details.service';
import { PnpZimplerService } from '../services/pnp-zimpler.service';
import { Utility } from '../shared/utility/utility';
import { CountryDataService } from '../services/country.service';
import Swiper from 'swiper';
@Component({
  selector: 'app-seo-content',
  templateUrl: './seo-content.component.html',
  styleUrls: ['./seo-content.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class SeoContentComponent implements OnInit, AfterViewInit, DoCheck {
  // swiperTestimonialConfig:SwiperOptions = swiperGrid4Config;
  // swiperCardsConfig:SwiperOptions = swiperSeoConfig;
  websiteName = environment.website_name;
  websiteLogoExtension = environment.website_logo_extension;
  langCode = 'en';
  destroy$: Subject<boolean> = new Subject();
  getLobbyGameGroups;
  apiUrl = environment.apiUrl
  mediaPath = environment.mediaPath;
  isCountryAllowed: number = 0;
  isZimplerProfile: boolean = false;
  isUserLoggedIn;
  windowType;

  constructor(
    private emitterService: EmitterService,
    private gameWindowService: GameWindowService,
    private router: Router,
    private userDetailsService: UserDetailsService,
    private pnpService: PnpZimplerService,
    private utils: Utility,
    private countryDataService: CountryDataService
  ) { 
    this.langCode = localStorage.getItem('langCode');
    this.emitterService.langCodeSource$.pipe(takeUntil(this.destroy$)).subscribe(langCode => {
      this.langCode = langCode;
    });

    this.emitterService.userCountry$.pipe(takeUntil(this.destroy$)).subscribe(country=>{
      if (environment.trustlyCountries.indexOf(country) >= 0) {
        this.getCountry(country);
      } else {
        this.getCountry();
      }
    });
    
    this.emitterService.isZimplerForm$.pipe(takeUntil(this.destroy$)).subscribe(data=>{
      this.isZimplerProfile = data;
    });
    
    this.emitterService.loginComplete$.pipe(takeUntil(this.destroy$)).subscribe(loginStatus => {
      this.isUserLoggedIn = true;
    });
  }

  ngOnInit() {
    this.getCountry();
    this.isUserLoggedIn = this.utils.isUserLoggedIn();
    this.gameWindowService.getLobbies().subscribe(data => {
      _.each(data, (lobby) => {
        if(lobby.name === 'seo_content_tabs') {
          this.getLobbyGameGroups = lobby["gameGroupList"];
        }
      });
    });
  }

  ngAfterViewInit(){

    setTimeout(() => {
      const ww = document.body.clientWidth;
      if (ww <= 992) {
        this.windowType = "mobile";
      } else {
        this.windowType = "desktop";
      }
      this.initializeSwiper();
    },);
    
      
  }
  ngDoCheck(): void {
    this.seoSwiperTransform();
  }

  getCountry(country?: String) {
    if (environment.zimplerCountries.indexOf(this.countryDataService.ipCountry.toUpperCase()) >= 0 || environment.semiPnpZimplerCountries.indexOf(this.countryDataService.ipCountry.toUpperCase()) >= 0) {
      this.isCountryAllowed = 1;
    } else {
      this.isCountryAllowed = 2;
    }
  }

  register() {
    this.emitterService.broadCastXSaleRegistration(true)
  }

  moveToTrustlyPay(){
    this.pnpService.openZimplerDeposit();
  }

  initializeSwiper() {
    setTimeout(() => {
      new Swiper(('.seo-swiper'), {
        slidesPerView: 1.059,
        slidesPerGroup: 1,
        spaceBetween: 20,
        freeMode: true,
        breakpoints:{
          '640': {
            slidesPerView: 1.05
          }
        }

      });
    });
  }
  // Adding position to swiper
  seoSwiperTransform() {
    const activeIndex = $('.seo-swiper > .swiper-wrapper').children('.swiper-slide-active').index();
    const ww = document.body.clientWidth;
    let translateValue :any;
      if (ww < 350) {
        translateValue = -101.9;
      } else if (ww < 360){
        translateValue = -101;
      } else if (ww < 375){
        translateValue = -100.5;
      } else if (ww <= 767){
        translateValue = -100.1                   ;
      } else {
        translateValue = -100.1
      }   
      $('.seo-swiper > .swiper-wrapper').css('transform', `translate(${translateValue * activeIndex + "%"} , 0)`); 
  }
  
  ngOnDestroy(){
    this.destroy$.next(true);
    this.destroy$.complete();
  }
}
